





































































import EditForm from '@/modules/core/components/EditForm.vue';
import AgencySelect from '@/modules/agency/components/AgencySelect.vue';
import SubscriptionConfig from './SubscriptionConfig.vue';
import { subscriptionApi } from '../subscription.api';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SubscriptionFormModel } from '../subscription.form-model';
import EditFormClass from '@/modules/core/components/EditForm';
import { plainToClass } from 'class-transformer';
import { OfferType } from '@/shared/common/types/offer-type';
import { RoleType } from '@/shared/common/types';
import { appService } from '../../../app.service';

@Component({
  components: {
    EditForm,
    AgencySelect,
    SubscriptionConfig,
  },
})
export default class SubscriptionEdit extends EditFormClass {
  public originalLabel = '';
  public formModel = new SubscriptionFormModel();
  public entityCreatedMsg = 'Programmation créée';
  public entityUpdatedMsg = 'Programmation mise à jour';
  public formModelClass = SubscriptionFormModel;
  public api = subscriptionApi;
  public offerTypes = Object.values(OfferType);
  public RoleType = RoleType;
  public OfferType = OfferType;
  public showCommentWarning = false;
  public commentWarningMsgHtml = appService.commentWarningMsgHtml;

  @Prop({
    default: null,
  })
  public subscriptionId!: string;

  @Prop({
    default: null,
  })
  public subscription!: any;

  public get cardTitle(): string {
    return this.creation
      ? 'Nouvelle programmation'
      : `Edition de la programmation ${this.originalLabel}`;
  }

  public get entityId(): string {
    return this.subscriptionId;
  }

  public get creation(): boolean {
    return !this.subscription && !this.subscriptionId;
  }

  public get saveLabel(): string {
    return this.creation ? 'Créer' : 'Enregistrer';
  }

  public mounted(): void {
    if (!this.$isAdmin()) {
      this.formModel.agencyId = this.$user.agencyId;
    }
  }

  @Watch('subscriptionId', { immediate: true })
  public async onSubscriptionIdChange(newVal: string): Promise<void> {
    if (newVal) {
      this.getEntity();
    } else {
      this.fetchedEntity = null;
    }
  }

  @Watch('formModel', { immediate: true })
  public onSubscriptionChange(): void {
    this.originalLabel = this.formModel.label;
  }

  @Watch('subscription', { immediate: true })
  public onSubscriptionPropChange(): void {
    if (this.subscription) {
      this.formModel = plainToClass(SubscriptionFormModel, this.subscription);
      this.formModel.original = this.subscription;
    }
  }
}
